export const PRODUCT_COLOR_LIST = [
  {
    key: 'Multiplayer',
    value: [
      '#CC5120',
      '#F77234',
      '#F99057',
      '#FAAC7B',
      '#FCC59F',
      '#FDDDC3',
      '#FFF3E8',
    ],
  },
  {
    key: 'Social',
    value: [
      '#0DA5AA',
      '#14C9C9',
      '#37D4CF',
      '#5EDFD6',
      '#89E9E0',
      '#B7F4EC',
      '#E8FFFB',
    ],
  },
  {
    key: 'Economy',
    value: [
      '#CC9213',
      '#F7BA1E',
      '#F9CC45',
      '#FADC6D',
      '#FCE996',
      '#FDF4BF',
      '#FFFCE8',
    ],
  },
  {
    key: 'Engagement',
    value: [
      '#CE2844',
      '#F94159',
      '#FA6271',
      '#FB838B',
      '#FDA4A7',
      '#FEC6C6',
      '#FFE9E8',
    ],
  },
  {
    key: 'Analytics',
    value: [
      '#0E42D2',
      '#165DFF',
      '#4080FF',
      '#6AA1FF',
      '#94BFFF',
      '#BEDAFF',
      '#E8F3FF',
    ],
  },
  {
    key: 'Content',
    value: [
      '#551DB0',
      '#722ED1',
      '#8D4EDA',
      '#A871E3',
      '#C396ED',
      '#DDBEF6',
      '#F5E8FF',
    ],
  },
];
export const DEFAULT_COLOR_LIST = [
  '#5764F1',
  '#7382F4',
  '#8F9FF7',
  '#ACBAF9',
  '#CAD5FC',
  '#3491FA',
  '#57A9FB',
  '#7BC0FC',
  '#9FD4FD',
  '#C3E7FE',
];
